import { useState } from 'react';

import AccordionPanel from './AccordionPanel';

import styles from './Accordion.module.scss';

type AccordionItem = {
  label: string;
  content: string;
};

type AccordionProps = {
  data: AccordionItem[];
};

const Accordion = ({ data }: AccordionProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const activateTab = index => {
    setActiveTab(prev => (prev === index ? -1 : index));
  };

  return (
    <div className={styles.container} role="tablist">
      {data.map(({ label, content }, index) => (
        <AccordionPanel
          key={label}
          activeTab={activeTab}
          index={index}
          label={label}
          content={content}
          activateTab={() => activateTab(index)}
        />
      ))}
    </div>
  );
};

export default Accordion;
